import { setContext } from '@apollo/client/link/context';

import { getJourneyId } from '../journeyId';
import { Server } from './types';

/** Request header the telehealth server reads to tag traces and logs. */
export const JOURNEY_ID_HEADER = 'x-journey-id';

/**
 * Adds the journey id to telehealth GraphQL requests so backend traces and
 * logs can be filtered by `journey.id` / `journey_id`. Requests to any other
 * server are left alone. Telehealth is the default when no server is set,
 * matching the http link split.
 */
export const journeyIdLink = setContext((_, ctx) =>
  (ctx.server ?? Server.TELEHEALTH) === Server.TELEHEALTH
    ? {
        ...ctx,
        headers: {
          ...ctx.headers,
          [JOURNEY_ID_HEADER]: getJourneyId(),
        },
      }
    : ctx,
);
